import SkeletonItem from './src/index.vue'

export default SkeletonItem
